import { defineStore } from "pinia";


export const sidebarList = [
  {
    title: "sidebar.dashboard",
    icon: "mdi mdi-cellphone-link",
    to: "/dashboard",
  },
  {
    title: "sidebar.activity",
    icon: "mdi mdi-history",
    to: "/dashboard/activity",
  },
  {
    title: "sidebar.2fa",
    icon: "mdi mdi-fingerprint",
    to: "/dashboard/2fa",
  },
  {
    title: "sidebar.installer",
    icon: "mdi mdi-download",
    to: "/dashboard/installer",
  },
  {
    title: "sidebar.agents",
    icon: "mdi mdi-account-eye",
    to: "/dashboard/agents",
  },
  {
    title: 'sidebar.incidents',
    icon: "mdi mdi-shield-alert",
    to: "/dashboard/incidents",
  },
  {
    title: "sidebar.faq",
    icon: "mdi mdi-frequently-asked-questions",
    to: "/dashboard/faq",
  },
  {
    title: "sidebar.supports",
    icon: "mdi mdi-face-agent",
    to: "/dashboard/supports",
  }
];


export const sidebarData = defineStore('sidebarData', {
  state: () => ({
    selectedSideBar: "sidebar.dashboard"
  }),
  persist: true
})
